import type { Dict } from "../core.js";
import type { labFlows as vi } from "../vi/labFlows.js";

export const labFlows: Dict<typeof vi> = {
  section: "Scenarios",
  "flow.suite": "Read-only suite",
  "flow.va": "Standard VA flow",
  "flow.bankLink": "Bank Link flow",
  "help.suite": "Runs the READ-ONLY calls back to back — changes nothing at Tingee. Tells you the set is alive and has the needed permissions.",
  "help.va": "Tingee's standard flow: create VA ⇒ confirm ⇒ subscribe to balance notifications ⇒ wait for money ⇒ reconcile. Each step starts when the previous one is done.",
  "help.bankLink": "The customer links inside the Tingee widget (bank, sign-in, OTP) ⇒ wait for the link webhook ⇒ wait for money ⇒ reconcile.",
  run: "Run",
  rerun: "Run again",
  reset: "Start over",
  start: "Start",
  merchantId: "Merchant ID (optional)",
  bank: "Bank",
  loadBanks: "Load bank list",
  accountType: "Account type",
  "accountType.personal-account": "Personal",
  "accountType.business-account": "Business",
  "accountType.business-household-account": "Household business",
  mode: "How to receive notifications",
  "mode.va": "Virtual account (VA)",
  "mode.account": "Original account number",
  accountNumber: "Account number",
  accountName: "Account holder",
  identity: "ID card / tax code",
  mobile: "Phone number for OTP",
  subscribeNotify: "Subscribe to balance notifications separately — banks such as ACB require it",
  allowedBanks: "Only show these banks (codes, comma-separated — empty = all)",
  otp: "OTP code",
  submitOtp: "Confirm OTP",
  confirmTwice: "Click again to SEND FOR REAL",
  openLink: "Open the bank's confirmation page",
  reopenWidget: "Reopen the widget",
  "step.banks": "Bank list",
  "step.transactions": "Transactions, last 24h",
  "step.vaPaging": "VA list",
  "step.shops": "Shops",
  "step.create": "Create VA (create-va)",
  "step.confirm": "Confirm",
  "step.notify": "Subscribe to balance notifications",
  "step.session": "Create link session",
  "step.widget": "Customer links in the widget",
  "step.linked": "Link webhook (bank-link)",
  "step.payment": "Wait for a balance change",
  "step.reconcile": "Reconcile (transaction/get-paging)",
  "status.idle": "Not run",
  "status.running": "Running…",
  "status.waiting": "Waiting…",
  "status.ok": "Passed",
  "status.failed": "Failed",
  "status.skipped": "Skipped",
  needMerchant: "Needs a Merchant ID",
  waitOtp: "Enter the OTP the bank sent.",
  waitLink: "Open the bank page, sign in and approve — Tingee reports back with a VA-status webhook.",
  notNeeded: "This bank needs no separate step.",
  waitPayment: "Transfer a few thousand VND to {number}. Incoming money shows up here (signature-checked webhook).",
  paymentCount: "{n} incoming payments",
  vaNotOwn: "Transfer to the VA NUMBER above — money sent to the original account {own} will NOT be notified (the link is in VA mode).",
  alphaVaNote: "The number above (with letters) is a VPBank VA (on original account {own}) — transfer to this VA. Whether a transfer straight to the original account is notified: not measured.",
  reconcileNow: "Reconcile now",
  reconcileResult: "Webhook {w} · Pulled {p} · Matched {m} · Webhook only {wo} · Missed webhooks {po}",
  vaReady: "VA {va} · {bank}",
  needPublicWebhook: "The webhook is a local address — Tingee cannot reach it. Open a tunnel and set HQ_PUBLIC_API_URL.",
  needBank: "Pick a bank first.",
  vaPrefix: "VA prefix (BIDV / VietinBank business)",
  vaSuffix: "VA suffix (BIDV / VietinBank / OCB business)",
  merchantName: "Merchant name (must start with the company legal name)",
  taxCode: "Tax code",
  merchantAddress: "Company address",
  acbUserId: "ACB User ID (ACB household / business)",
  "confirm.otp": "Confirmation: OTP sent by the bank.",
  "confirm.deep_link": "Confirmation: the customer approves in the bank app (VCB Digibank) — result arrives by webhook.",
  "confirm.authorize_link": "Confirmation: sign in to TPBank BIZ to approve — result arrives by webhook.",
  ruleMissing: "Missing: {fields}",
  "setup.api": "The business account must be configured via API FIRST (/docs/cau-hinh-tai-khoan-dn) — otherwise Tingee rejects it.",
  "setup.tingee": "Ask Tingee to configure the business account FIRST.",
  "setup.ibusiness": "The customer must enable « nhận loa » in VIB iBusiness FIRST.",
  metadataEchoed: "Tingee echoed metadata ✓",
  metadataMissing: "Tingee did NOT echo metadata ✗",
  durationMs: "{ms} ms",
};
